import { useEffect, useState } from "react";
import api from "@/lib/api";
import { fmtDateDay } from "@/lib/dates";
import { toast } from "sonner";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { GraduationCap, CalendarDays, CheckCircle2, Loader2 } from "lucide-react";

const showDate = (d) => (d ? fmtDateDay(d) : "Date to be confirmed");

export const MyTrainings = () => {
  const [items, setItems] = useState([]);
  const [busy, setBusy] = useState(null);

  const load = () => api.get("/me/trainings").then((r) => setItems(r.data || [])).catch(() => {});
  useEffect(() => { load(); }, []);

  const enrol = async (t) => {
    setBusy(t.id);
    try {
      await api.post(`/me/trainings/${t.id}/enroll`);
      toast.success(`You're enrolled in ${t.name}`);
      load();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Could not enrol");
    } finally { setBusy(null); }
  };

  const confirmed = items.filter((t) => t.enrolled).length;

  return (
    <Card className="bg-white border border-[#E5E0D8] shadow-sm overflow-hidden" data-testid="portal-trainings">
      <div className="flex items-center gap-2 p-5 border-b border-[#E5E0D8]">
        <GraduationCap className="h-5 w-5 text-[#0284C7]" />
        <h2 className="font-serif text-xl font-semibold">Trainings</h2>
        <Badge variant="outline" className="ml-auto bg-[#E0F2FE] text-[#0369A1] border-[#BAE6FD]" data-testid="portal-trainings-count">
          {confirmed} confirmed
        </Badge>
      </div>
      <ul className="divide-y divide-[#E5E0D8]">
        {items.map((t) => (
          <li key={t.id} className="p-5 flex flex-col sm:flex-row sm:items-center gap-3" data-testid={`portal-training-${t.id}`}>
            <div className="flex-1 min-w-0">
              <p className="font-medium text-[#1C241B]">{t.name}</p>
              <p className="mt-0.5 flex items-center gap-1.5 text-xs text-[#7A8A78]">
                <CalendarDays className="h-3.5 w-3.5" />{showDate(t.date)}
              </p>
              {t.description && <p className="mt-1.5 text-sm text-[#526050]">{t.description}</p>}
            </div>
            {t.enrolled ? (
              <Badge className="self-start sm:self-center bg-[#EAF2E8] text-[#2D5A27] border border-[#cfe3cb] hover:bg-[#EAF2E8] px-3 py-1.5"
                data-testid={`portal-training-confirmed-${t.id}`}>
                <CheckCircle2 className="h-4 w-4 mr-1.5" /> Confirmed
              </Badge>
            ) : (
              <Button onClick={() => enrol(t)} disabled={busy === t.id} data-testid={`portal-training-enrol-${t.id}`}
                className="self-start sm:self-center bg-[#2D5A27] hover:bg-[#23471F] text-white">
                {busy === t.id && <Loader2 className="h-4 w-4 mr-2 animate-spin" />} Enrol
              </Button>
            )}
          </li>
        ))}
        {items.length === 0 && <li className="p-10 text-center text-[#7A8A78]">No trainings available right now.</li>}
      </ul>
    </Card>
  );
};
